import React from 'react'

// import Box from '@mui/material/Box'

type Props = React.PropsWithChildren<{
  hidden: boolean
  id: string
  ariaLabelledby: string
}>

const TabPanel = ({ hidden, children, id, ariaLabelledby, ...rest }: Props) => {
  return (
    <div
      role="tabpanel"
      hidden={hidden}
      id={id}
      aria-labelledby={ariaLabelledby}
      {...rest}
    >
      {!hidden && (
        <div>
          {children}
        </div>
      )}
    </div>
  )
}

export default TabPanel
